<template>
  <v-snackbar
    v-model="generalStore.snackOpened"
    min-height="68"
    max-width="500"
  >
    <span class="snack-box">
      <span v-if="generalStore.snackType=== 'warning'">Something went wrong <br></span>
      <span v-html="generalStore.snackText" />
    </span>
    <template #actions="{props}">
      <v-btn
        color="primary"
        variant="text"
        v-bind="props"
        @click="generalStore.snackOpened = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>

import { useGeneralStore } from '@/store/pinia/generalStore'

export default {
  name: 'Snackbar',
  setup () {
    return {
      generalStore: useGeneralStore(),
    }
  },
}
</script>

<style lang="scss">
.snack-box {
  font-size: 18px;
}
</style>
